import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Divider,
  Step,
  StepLabel,
  Stepper,
  styled,
  TextField,
  Autocomplete,
  Tooltip,
} from "@mui/material";
import { Formik, Form, FieldArray, Field } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import CloseIcon from "@mui/icons-material/Close";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { updateEmployee } from "../../services/user.service";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import { getProject } from "../../services/project.service";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { FileUploader } from "react-drag-drop-files";
import { encryptData } from "../../utils/cryptoUtils";

const AddUser = (props) => {
  const { setOpenDrawer, formType, GetData, selectedData } = props;
  const disabled = formType === "view";
  const disabledEdit = formType === "edit";
  const formRef = useRef(null);
  const [projectData, setProjectData] = useState([]);
  const steps = [
    "User Profile",
    "Addres Field",
    "Mark List",
    "Employee Field",
    "Account Details",
  ];
  const [activeStep, setActiveStep] = useState(0);
  const CustomStepLabel = styled(StepLabel)(({ active, completed }) => ({
    "& .MuiStepLabel-iconContainer": {
      "& .MuiStepIcon-root": {
        color: completed ? "#138f6e" : active ? "#03d697" : "#03d697", // Icon color
        border: completed
          ? "1px solid #03d697"
          : active
          ? "1px solid #03d697"
          : "1px solid #03d697",
        borderRadius: "50%",
        width: 30,
        height: 30,
      },
      "& .MuiStepIcon-text": {
        fill: completed ? "#ffffff" : active ? "#ffffff" : "#00675D", // Text color inside the icon
      },
    },
  }));
  const handleNext = () => {
    if (activeStep === 0) {
      // Check if all required fields in step 0 are filled
      setActiveStep(1); // Move to address step
    } else if (activeStep === 1) {
      // If you need to handle validation or conditions for step 1
      setActiveStep(2); // Move to next step
    } else if (activeStep === 2) {
      setActiveStep(3);
    } else if (activeStep === 3) {
      setActiveStep(4);
    } else if (activeStep === 4) {
      // Logic for other steps if needed
      // Move to the last step or finish
    }
  };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };
  const [others, setOthers] = useState([]);

  const educationOptions = [
    { label: "Tenth", name: "tenth" },
    { label: "Twelfth", name: "twelfth" },
    { label: "Diploma", name: "diploma" },
    { label: "UG Degree", name: "UgDegree" },
    { label: "PG Degree", name: "PgDegree" },
  ];
  const initialValues = {
    firstName: selectedData.firstName || "",
    lastName: selectedData.lastName || "",
    email: selectedData.email || "",
    mobileNo: selectedData.mobileNo || "",
    secondaryMobileNo: selectedData.secondaryMobileNo || "",
    bloodGroup: selectedData.bloodGroup || "",
    dateOfBirth: selectedData.dateOfBirth || "",
    joiningDate: selectedData.joiningDate ? selectedData.joiningDate : "" || "",
    aadhaarNumber: selectedData.aadhaarNumber
      ? selectedData.aadhaarNumber
      : "" || "",
    panNumber: selectedData.panNumber ? selectedData.panNumber : "" || "",
    project: Array.isArray(selectedData.project)
      ? selectedData.project.map((project) => project._id)
      : [],
    // project: selectedData.project,
    address: {
      currentAddress: {
        doorNo_street:
          selectedData.address?.currentAddress?.doorNo_street || "",
        place: selectedData.address?.currentAddress?.place || "",
        pincode: selectedData.address?.currentAddress?.pincode || "",
        district: selectedData.address?.currentAddress?.district || "",
      },
      permanentAddress: {
        doorNo_street:
          selectedData.address?.permanentAddress?.doorNo_street || "",
        place: selectedData.address?.permanentAddress?.place || "",
        pincode: selectedData.address?.permanentAddress?.pincode || "",
        district: selectedData.address?.permanentAddress?.district || "",
      },
    },
    emergencyDetails: {
      name: selectedData.emergencyDetails?.name || "",
      relation: selectedData.emergencyDetails?.relation || "",
      mobileNo: selectedData.emergencyDetails?.mobileNo || "",
    },
    employeeDetails: {
      employeeDepartment:
        selectedData?.employeeDetails?.employeeDepartment || "",
      employeeRole: selectedData?.employeeDetails?.employeeRole || "",
      employeeStatus: selectedData.employeeDetails?.employeeStatus || "",
      employeeType: selectedData.employeeDetails?.employeeType || "",
    },
    personalInformation: {
      fatherName: selectedData.personalInformation?.fatherName || "",
      motherName: selectedData.personalInformation?.motherName || "",
      // siblings: selectedData.personalInformation?.siblings || [
      //   { name: "" },
      // ],
      siblings:
        Array.isArray(selectedData.personalInformation?.siblings) &&
        selectedData.personalInformation.siblings.length
          ? selectedData.personalInformation.siblings
          : [],
    },
    educationField: {
      tenth: {
        totalMarks: selectedData.educationField?.tenth?.totalMarks || "",
        yearOfPassing: selectedData.educationField?.tenth?.yearOfPassing || "",
        percentage: selectedData.educationField?.tenth?.percentage || "",
      },
      twelfth: {
        totalMarks: selectedData.educationField?.twelfth?.totalMarks || "",
        yearOfPassing:
          selectedData.educationField?.twelfth?.yearOfPassing || "",
        percentage: selectedData.educationField?.twelfth?.percentage || "",
      },
      diploma: {
        degree: selectedData.educationField?.diploma?.degree || "",
        yearOfPassing:
          selectedData.educationField?.diploma?.yearOfPassing || "",
        percentage: selectedData.educationField?.diploma?.percentage || "",
        specialization:
          selectedData.educationField?.diploma?.specialization || "",
      },
      UgDegree: {
        degree: selectedData.educationField?.UgDegree?.degree || "",
        yearOfPassing:
          selectedData.educationField?.UgDegree?.yearOfPassing || "",
        percentage: selectedData.educationField?.UgDegree?.percentage || "",
        specialization:
          selectedData.educationField?.UgDegree?.specialization || "",
      },
      PgDegree: {
        degree: selectedData.educationField?.PgDegree?.degree || "",
        yearOfPassing:
          selectedData.educationField?.PgDegree?.yearOfPassing || "",
        percentage: selectedData.educationField?.PgDegree?.percentage || "",
        specialization:
          selectedData.educationField?.PgDegree?.specialization || "",
      },
    },
    accountDetails: {
      accountNumber: selectedData.accountDetails?.accountNumber || "",
      accountHolderName: selectedData.accountDetails?.accountHolderName || "",
      bankName: selectedData.accountDetails?.bankName || "",
      bankBranch: selectedData.accountDetails?.bankBranch || "",
      IFSCNumber: selectedData.accountDetails?.IFSCNumber || "",
    },
    file: [],
  };
  const [fileName, setFileName] = useState(
    formType === "edit"
      ? selectedData?.file?.fileName
      : "Drag & Drop or click to upload videos"
  );
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    // email: Yup.string()
    //   .email("Invalid email format")
    //   .required("Email is required"),
    email: Yup.string()
      .required("Please enter email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address"
      )
      .test(
        "is-com",
        "Email must end with .com",
        (value) => value && value.endsWith(".com")
      ),
    // mobileNo: Yup.string()
    //   .required("Mobile Number is required")
    //   .min(2, "Mobile Number must be at least 10 characters"),
    mobileNo: Yup.string()
      .required("Mobile Number is required")
      .matches(
        /^[0-9]{10}$/,
        "Mobile Number must be 10 digits and contain only numbers"
      ),
    // secondaryMobileNo: Yup.string()
    //   .required("Alter Mobile Number is required")
    //   .min(2, "Alter Mobile Number must be at least 10 characters"),
    secondaryMobileNo: Yup.string()
      .required("Mobile Number is required")
      .matches(
        /^[0-9]{10}$/,
        "Mobile Number must be 10 digits and contain only numbers"
      ),
    dateOfBirth: Yup.string().required("Select Date of Birth"),
    bloodGroup: Yup.string().required("Blood Group is required"),
    joiningDate: Yup.date().required("Joining Date is required"),
    aadhaarNumber: Yup.number().required("Aadhaar Number is required"),
    panNumber: Yup.string().required("PAN Number is required"),
    project: Yup.array()
      .of(Yup.string().required("Project Required *"))
      .required("Project Required *"),
    password: Yup.string().required("Password is required"),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
    emergencyDetails: Yup.object().shape({
      name: Yup.string().required("Name is required"),
      relation: Yup.string().required("Relation is required"),
      mobileNo: Yup.string()
        .required("Mobile Number is required")
        .matches(
          /^[0-9]{10}$/,
          "Mobile Number must be 10 digits and contain only numbers"
        ),
    }),
    address: Yup.object().shape({
      currentAddress: Yup.object().shape({
        doorNo_street: Yup.string().required("Door No / Street is required"),
        place: Yup.string().required("Place is required"),
        pincode: Yup.string()
          .required("Pincode is required")
          .matches(/^\d{6}$/, "Pincode must be exactly 6 digits"),
        district: Yup.string().required("District is required"),
      }),
      permanentAddress: Yup.object().shape({
        doorNo_street: Yup.string().required("Door No / Street is required"),
        place: Yup.string().required("Place is required"),
        pincode: Yup.string()
          .required("Pincode is required")
          .matches(/^\d{6}$/, "Pincode must be exactly 6 digits"),
        district: Yup.string().required("District is required"),
      }),
    }),
    employeeDetails: Yup.object().shape({
      employeeDepartment: Yup.string().required(
        "Employee Department is required"
      ),
      employeeRole: Yup.string().required("Employee Role is required"),
      employeeStatus: Yup.string().required("Employee Status is required"),
      employeeType: Yup.string().required("Employee Type is required"),
    }),
    personalInformation: Yup.object().shape({
      fatherName: Yup.string().required("Father Name is required"),
      motherName: Yup.string().required("Mother Name is required"),
      // siblings: Yup.array().of(
      //   Yup.object().shape({
      //     name: Yup.string().required("Sibling name is required"),
      //   })
      // ),
      siblings: Yup.array().of(
        Yup.string().required("Sibling Name is required")
      ),
    }),
    accountDetails: Yup.object().shape({
      accountNumber: Yup.string().required("Account Number is required"),
      accountHolderName: Yup.string().required("AC Holder Name is required"),
      bankName: Yup.string().required("Bank Name is required"),
      bankBranch: Yup.string().required("Bank Branch is required"),
      IFSCNumber: Yup.string().required("IFSC Number is required"),
    }),
  });

  useEffect(() => {
    getProjectData();
    const fields = [];
    Object.keys(initialValues.educationField).forEach((key) => {
      if (selectedData.educationField?.[key]) {
        fields.push(key);
      }
    });
    setOthers(fields);
  }, [selectedData]);

  const getProjectData = async () => {
    try {
      const res = await getProject({ isEnabled: true });
      const configData = res.data.data.map((e) => {
        return {
          ...e,
          label: e.name,
        };
      });
      setProjectData(configData);
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmit = async (values) => {
    try {
      const formData = new FormData();
      const { files, ...bodyData } = values;

      const filteredBodyData = Object.fromEntries(
        Object.entries(bodyData).filter(([key, value]) => value !== "")
      );
      if (files && files.length) {
        files.forEach((file) => {
          formData.append("files", file);
        });
      }

      if (filteredBodyData.educationField) {
        Object.keys(filteredBodyData.educationField).forEach((field) => {
          const educationField = filteredBodyData.educationField[field];

          if (
            !others.includes(field) ||
            (educationField.totalMarks === "" &&
              educationField.yearOfPassing === "" &&
              educationField.percentage === "" &&
              (field === "diploma"
                ? educationField.specialization === ""
                : educationField.degree === "") &&
              (field === "UgDegree"
                ? educationField.specialization === ""
                : educationField.degree === "") &&
              (field === "PgDegree"
                ? educationField.specialization === ""
                : educationField.degree === ""))
          ) {
            delete filteredBodyData.educationField[field];
          }
        });
      }
      const encryptedBodyData = {};
      Object.keys(filteredBodyData).forEach((key) => {
        encryptedBodyData[key] = encryptData(filteredBodyData[key]);
      });

      formData.append("bodyData", JSON.stringify(encryptedBodyData));

      if (files && files.length) {
        files.forEach((file) => {
          formData.append("files", file);
        });
      }

      const apiMethod = updateEmployee(selectedData._id, formData);
      const res = await apiMethod;
      ToastSuccess(res.message);
      setOpenDrawer(false);
      GetData();
    } catch (error) {
      ToastError(error?.data?.message);
    }
  };

  return (
    <div className="addRenderingContainer">
      <Box className="addContainerHeader">
        {/* <Typography>
          {formType === "edit" ? "Edit" : formType === "view" ? "View" : "Add"}{" "}
          User
        </Typography>
        <CloseIcon
          sx={{ cursor: "pointer" }}
          onClick={() => setOpenDrawer(false)}
        /> */}
        <Grid container>
          <Grid item xs={12} display={"flex"} justifyContent={"center"}>
            <Stepper style={{ width: "50%" }} activeStep={activeStep}>
              {steps.map((label, index) => (
                <Step key={index}>
                  {/* <StepLabel>{label}</StepLabel> */}
                  <CustomStepLabel
                    active={index === activeStep}
                    completed={index < activeStep}
                  >
                    {/* {label} */}
                  </CustomStepLabel>
                </Step>
              ))}
            </Stepper>
            <CloseIcon
              sx={{ cursor: "pointer" }}
              onClick={() => setOpenDrawer(false)}
            />
          </Grid>
        </Grid>
      </Box>
      <Divider sx={{ opacity: 1 }} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={onSubmit}
        innerRef={formRef}
      >
        {({
          touched,
          errors,
          handleChange,
          handleBlur,
          setFieldValue,
          values,
        }) => (
          <Form>
            <Box className="addContainerCenter" mb={1}>
              <Grid container spacing={2}>
                {activeStep === 0 && (
                  <>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">First Name</Typography>
                      <Field
                        name="firstName"
                        className="InputField"
                        placeholder="Enter First Name"
                        disabled={disabled || disabledEdit}
                      />
                      <div className="form-error">
                        {touched.firstName &&
                          errors.firstName &&
                          errors.firstName}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Last Name</Typography>
                      <Field
                        name="lastName"
                        className="InputField"
                        placeholder="Enter First Name"
                        disabled={disabled || disabledEdit}
                      />
                      <div className="form-error">
                        {touched.lastName && errors.lastName && errors.lastName}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Email</Typography>
                      <Field
                        name="email"
                        className="InputField"
                        placeholder="Enter Email"
                        disabled={disabled || disabledEdit}
                      />
                      <div className="form-error">
                        {touched.email && errors.email && errors.email}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Date of Birth
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker", "DatePicker"]}
                        >
                          <DatePicker
                            value={
                              values?.dateOfBirth
                                ? dayjs(values?.dateOfBirth)
                                : null
                            }
                            onChange={(e) =>
                              setFieldValue(
                                "dateOfBirth",
                                dayjs(e.$d).format("MM/DD/YYYY")
                              )
                            }
                            className="datePicker w-100"
                            disabled={disabled}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <div className="form-error">
                        {touched.dateOfBirth &&
                          errors.dateOfBirth &&
                          errors.dateOfBirth}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Secondary Mobile No
                      </Typography>
                      <Field
                        name="secondaryMobileNo"
                        type="number"
                        className="InputField"
                        placeholder="Enter Mobile Number"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.secondaryMobileNo &&
                          errors.secondaryMobileNo &&
                          errors.secondaryMobileNo}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Blood Group
                      </Typography>
                      <Field
                        name="bloodGroup"
                        maxLength={3}
                        className="InputField"
                        placeholder="Enter Your Blood Group"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.bloodGroup &&
                          errors.bloodGroup &&
                          errors.bloodGroup}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Aadhaar Number
                      </Typography>
                      <Field
                        name="aadhaarNumber"
                        className="InputField"
                        placeholder="Enter Your Aadhaar Number"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.aadhaarNumber &&
                          errors.aadhaarNumber &&
                          errors.aadhaarNumber}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Pan Number</Typography>
                      <Field
                        name="panNumber"
                        className="InputField"
                        placeholder="Enter Your Pan Number"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.panNumber &&
                          errors.panNumber &&
                          errors.panNumber}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} mt={1} className="File-Upload">
                      {/* <div className="wsh-form-control"> */}
                      <Typography className="inputLabel">
                        Add Profile
                      </Typography>
                      <FileUploader
                        handleChange={(e) => {
                          const files =
                            e instanceof FileList ? Array.from(e) : [e];
                          setFieldValue("files", files);
                          setFileName(
                            files.map((file) => file.name).join(", ")
                          );
                        }}
                        name="files"
                        multiple={true}
                        dropMessageStyle={{
                          color: "green",
                          border: "none",
                          borderRadius: "0px",
                        }}
                      />
                      <Box className="uploadIcon">
                        <CloudUploadOutlinedIcon />
                        {fileName ? (
                          <span>{fileName}</span>
                        ) : (
                          "Drag & Drop or click to upload files"
                        )}
                      </Box>
                      {/* <div className="form-error">
                        {touched.file && errors.file && errors.file}
                      </div>
                    </div> */}
                    </Grid>
                    <Grid item xs={12} sm={12} mt={1}>
                      <Typography className="additionalInputLabel">
                        Emergency Details
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Name</Typography>
                      <Field
                        // disabled={ddisabled}
                        name="emergencyDetails.name"
                        className="InputField"
                        disabled={disabled}
                        placeholder="Enter Name"
                      />
                      <div className="form-error">
                        {touched.emergencyDetails?.name &&
                          errors.emergencyDetails?.name &&
                          errors.emergencyDetails?.name}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Relation</Typography>
                      <Field
                        // disabled={ddisabled}
                        name="emergencyDetails.relation"
                        className="InputField"
                        disabled={disabled}
                        placeholder="Enter Relation"
                      />
                      <div className="form-error">
                        {touched.emergencyDetails?.relation &&
                          errors.emergencyDetails?.relation &&
                          errors.emergencyDetails?.relation}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Mobile</Typography>
                      <Field
                        // disabled={ddisabled}
                        name="emergencyDetails.mobileNo"
                        type="number"
                        className="InputField"
                        disabled={disabled}
                        placeholder="Enter Mobile Number"
                      />
                      <div className="form-error">
                        {touched.emergencyDetails?.mobileNo &&
                          errors.emergencyDetails?.mobileNo &&
                          errors.emergencyDetails?.mobileNo}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} mt={1}>
                      <Typography className="additionalInputLabel">
                        Personal Information
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Father Name
                      </Typography>
                      <Field
                        disabled={disabled}
                        name="personalInformation.fatherName"
                        className="InputField"
                        placeholder="Enter Father Name"
                      />
                      <div className="form-error">
                        {touched.personalInformation?.fatherName &&
                          errors.personalInformation?.fatherName &&
                          errors.personalInformation?.fatherName}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Mother Name
                      </Typography>
                      <Field
                        disabled={disabled}
                        name="personalInformation.motherName"
                        className="InputField"
                        placeholder="Enter Relation"
                      />
                      <div className="form-error">
                        {touched.personalInformation?.motherName &&
                          errors.personalInformation?.motherName &&
                          errors.personalInformation?.motherName}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} mt={1}>
                      <Typography className="inputLabel">Sibling</Typography>
                      <FieldArray name={`personalInformation.siblings`}>
                        {({ push, remove }) => (
                          <div>
                            {values?.personalInformation?.siblings?.map(
                              (sibling, index) => (
                                <Grid
                                  container
                                  spacing={2}
                                  key={index}
                                  sx={{ display: "flex" }}
                                >
                                  <Grid item xs={12} sm={6} mt={1}>
                                    <Field
                                      name={`personalInformation.siblings.${index}`} // Adjust the name if you have a specific structure
                                      className="InputField w-100"
                                      disabled={disabled}
                                      placeholder={`Enter Sibling Name`} // Adjust placeholder as needed
                                    />
                                    <div className="form-error">
                                      {touched.personalInformation?.siblings?.[
                                        index
                                      ] &&
                                        errors.personalInformation?.siblings?.[
                                          index
                                        ]}
                                    </div>
                                  </Grid>
                                  <Grid item xs={12} sm={6} mt={1}>
                                    <Button
                                      onClick={() => remove(index)}
                                      sx={{
                                        // backgroundColor:
                                        //   "rgba(213, 215, 232, 1)",
                                        // border: "1px solid white",
                                        borderRadius: "6px",
                                        height: "36px",
                                        width: "36px",
                                        minWidth: "10px",
                                      }}
                                    >
                                      <DeleteOutlineIcon
                                        sx={{ color: "rgba(255, 0, 0, 1)" }}
                                      />
                                    </Button>
                                  </Grid>
                                </Grid>
                              )
                            )}
                            <Tooltip title="Add">
                              <Button
                                onClick={() => push("")} // Push an empty string or object for new sibling
                                sx={{
                                  // backgroundColor: "rgba(213, 215, 232, 1)",
                                  // border: "1px solid white",
                                  borderRadius: "6px",
                                  height: "36px",
                                  width: "36px",
                                  minWidth: "10px",
                                  marginTop: "10px",
                                }}
                                disabled={disabled}
                              >
                                <AddIcon
                                  sx={{ color: "rgba(26, 1, 129, 1)" }}
                                />
                              </Button>
                            </Tooltip>
                          </div>
                        )}
                      </FieldArray>
                    </Grid>
                  </>
                )}
                {activeStep === 1 && (
                  <>
                    <Grid item xs={12} sm={12} mt={1}>
                      <Typography className="additionalInputLabel">
                        Current Address
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Door No / Street
                      </Typography>
                      <Field
                        name="address.currentAddress.doorNo_street"
                        className="InputField w-100"
                        disabled={disabled}
                        placeholder="Enter Door No & Street"
                      />
                      <div className="form-error">
                        {touched.address?.currentAddress?.doorNo_street &&
                          errors.address?.currentAddress?.doorNo_street &&
                          errors.address?.currentAddress?.doorNo_street}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Place</Typography>
                      <Field
                        name="address.currentAddress.place"
                        className="InputField w-100"
                        disabled={disabled}
                        placeholder="Enter Place"
                      />
                      <div className="form-error">
                        {touched.address?.currentAddress?.place &&
                          errors.address?.currentAddress?.place &&
                          errors.address?.currentAddress?.place}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">District</Typography>
                      <Field
                        name="address.currentAddress.district"
                        className="InputField w-100"
                        disabled={disabled}
                        placeholder="Enter District"
                      />
                      <div className="form-error">
                        {touched.address?.currentAddress?.district &&
                          errors.address?.currentAddress?.district &&
                          errors.address?.currentAddress?.district}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Pincode</Typography>
                      <Field
                        name="address.currentAddress.pincode"
                        className="InputField w-100"
                        disabled={disabled}
                        placeholder="Enter Pincode"
                      />
                      <div className="form-error">
                        {touched.address?.currentAddress?.pincode &&
                          errors.address?.currentAddress?.pincode &&
                          errors.address?.currentAddress?.pincode}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} mt={1}>
                      <Typography className="additionalInputLabel">
                        Permanent Address
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      {/* <Grid
                        sx={{
                          display: "flex",
                          gap: "20px",
                          // justifyContent: "space-between",
                        }}
                      > */}
                      <Typography className="inputLabel">
                        Door No / Street
                      </Typography>
                      {/* </Grid> */}
                      <Field
                        name="address.permanentAddress.doorNo_street"
                        className="InputField w-100"
                        disabled={disabled}
                        placeholder="Enter Door No & Street"
                      />
                      <div className="form-error">
                        {touched.address?.permanentAddress?.doorNo_street &&
                          errors.address?.permanentAddress?.doorNo_street &&
                          errors.address?.permanentAddress?.doorNo_street}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Place</Typography>
                      <Field
                        name="address.permanentAddress.place"
                        className="InputField w-100"
                        disabled={disabled}
                        placeholder="Enter Place"
                      />
                      <div className="form-error">
                        {touched.address?.permanentAddress?.place &&
                          errors.address?.permanentAddress?.place &&
                          errors.address?.permanentAddress?.place}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">District</Typography>
                      <Field
                        name="address.permanentAddress.district"
                        className="InputField w-100"
                        disabled={disabled}
                        placeholder="Enter District"
                      />
                      <div className="form-error">
                        {touched.address?.permanentAddress?.district &&
                          errors.address?.permanentAddress?.district &&
                          errors.address?.permanentAddress?.district}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Pincode</Typography>
                      <Field
                        name="address.permanentAddress.pincode"
                        className="InputField w-100"
                        disabled={disabled}
                        placeholder="Enter Pincode"
                      />
                      <div className="form-error">
                        {touched.address?.permanentAddress?.pincode &&
                          errors.address?.permanentAddress?.pincode &&
                          errors.address?.permanentAddress?.pincode}
                      </div>
                    </Grid>
                  </>
                )}
                {activeStep === 2 && (
                  <>
                    <Grid item xs={12} sm={12} mt={1}>
                      <div className="wsh-form-control">
                        <Typography className="inputLabel">
                          Education Field
                        </Typography>
                        <Autocomplete
                          multiple
                          disabled={disabled}
                          disableClearable={true}
                          options={educationOptions}
                          // getOptionLabel={(option) => option.label}
                          // value={(values.educationField || []).map((name) =>
                          //   educationOptions.find(
                          //     (option) => option.name === name
                          //   )
                          // )}
                          // value={(Array.isArray(values.educationField)
                          //   ? values.educationField
                          //   : []
                          // ).map((name) =>
                          //   educationOptions.find(
                          //     (option) => option.name === values.educationField
                          //   )
                          // )}
                          value={others.map((name) =>
                            educationOptions.find(
                              (option) => option.name === name
                            )
                          )}
                          onChange={(e, v) => {
                            const newSelectedFields = v.map(
                              (option) => option.name
                            );
                            setOthers(newSelectedFields);

                            newSelectedFields.forEach((field) => {
                              if (!v.find((option) => option.name === field)) {
                                setFieldValue(`educationField.${field}`, {
                                  totalMarks: "",
                                  yearOfPassing: "",
                                  percentage: "",
                                  ...(field === "UgDegree"
                                    ? { specialization: "" }
                                    : {}),
                                  ...(field === "PgDegree"
                                    ? { thesisTitle: "" }
                                    : {}),
                                });
                              }
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              focused={false}
                              placeholder="Select Education Field"
                              className="AutoComplete_InputBox"
                            />
                          )}
                        />
                        <div className="form-error">
                          {touched.educationField &&
                            errors.educationField &&
                            errors.educationField}
                        </div>
                      </div>
                    </Grid>
                    {/* Conditional rendering based on selected options */}
                    {others.includes("tenth") && (
                      <>
                        <Grid item xs={12} sm={12} mt={1}>
                          <Typography className="additionalInputLabel">
                            10th Details
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Total Marks
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.tenth.totalMarks"
                            className="InputField w-100"
                            placeholder="Enter Total Marks"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Percentage
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.tenth.percentage"
                            className="InputField w-100"
                            placeholder="Enter Percentage"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Year Of Completion
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.tenth.yearOfPassing"
                            className="InputField w-100"
                            placeholder="Enter Year Of Completed"
                          />
                        </Grid>
                      </>
                    )}
                    {others.includes("twelfth") && (
                      <>
                        <Grid item xs={12} sm={12} mt={1}>
                          <Typography className="additionalInputLabel">
                            12th Details
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Total Marks
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.twelfth.totalMarks"
                            className="InputField w-100"
                            placeholder="Enter Total Marks"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Percentage
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.twelfth.percentage"
                            className="InputField w-100"
                            placeholder="Enter Percentage"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Year Of Completion
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.twelfth.yearOfPassing"
                            className="InputField w-100"
                            placeholder="Enter Year Of Completed"
                          />
                        </Grid>
                      </>
                    )}
                    {others.includes("diploma") && (
                      <>
                        <Grid item xs={12} sm={12} mt={1}>
                          <Typography className="additionalInputLabel">
                            Diploma
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">Degree</Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.diploma.degree"
                            className="InputField w-100"
                            placeholder="Enter Degree"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Specialization
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.diploma.specialization"
                            className="InputField w-100"
                            placeholder="Enter Specialzation"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Percentage
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.diploma.percentage"
                            className="InputField w-100"
                            placeholder="Enter Percentage"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Year Of Completion
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.diploma.yearOfPassing"
                            className="InputField w-100"
                            placeholder="Enter Year Of Completed"
                          />
                        </Grid>
                      </>
                    )}
                    {others.includes("UgDegree") && (
                      <>
                        <Grid item xs={12} sm={12} mt={1}>
                          <Typography className="additionalInputLabel">
                            UG Degree
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">Degree</Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.UgDegree.degree"
                            className="InputField w-100"
                            placeholder="Enter Degree"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Specialization
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.UgDegree.specialization"
                            className="InputField w-100"
                            placeholder="Enter Specialization"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Percentage
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.UgDegree.percentage"
                            className="InputField w-100"
                            placeholder="Enter Percentage"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Year Of Completion
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.UgDegree.yearOfPassing"
                            className="InputField w-100"
                            placeholder="Enter Year Of Completed"
                          />
                        </Grid>
                      </>
                    )}
                    {others.includes("PgDegree") && (
                      <>
                        <Grid item xs={12} sm={12} mt={1}>
                          <Typography className="additionalInputLabel">
                            PG Degree
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">Degree</Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.PgDegree.degree"
                            className="InputField w-100"
                            placeholder="Enter Degree"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Specialization
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.PgDegree.specialization"
                            className="InputField w-100"
                            placeholder="Enter Specialization"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Percentage
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.PgDegree.percentage"
                            className="InputField w-100"
                            placeholder="Enter Percentage"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} mt={1}>
                          <Typography className="inputLabel">
                            Year Of Completion
                          </Typography>
                          <Field
                            disabled={disabled}
                            name="educationField.PgDegree.yearOfPassing"
                            className="InputField w-100"
                            placeholder="Enter Year Of Completed"
                          />
                        </Grid>
                      </>
                    )}
                  </>
                )}

                {activeStep === 3 && (
                  <>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Employee Department
                      </Typography>
                      <Field
                        name="employeeDetails.employeeDepartment"
                        className="InputField w-100"
                        placeholder="Enter Employee Department"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.employeeDetails?.employeeDepartment &&
                          errors.employeeDetails?.employeeDepartment &&
                          errors.employeeDetails?.employeeDepartment}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Employee Role
                      </Typography>
                      <Field
                        name="employeeDetails.employeeRole"
                        className="InputField w-100"
                        placeholder="Enter Employee Role"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.employeeDetails?.employeeRole &&
                          errors.employeeDetails?.employeeRole &&
                          errors.employeeDetails?.employeeRole}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Employee Status
                      </Typography>
                      <Field
                        name="employeeDetails.employeeStatus"
                        className="InputField w-100"
                        placeholder="Enter Employee Status"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.employeeDetails?.employeeStatus &&
                          errors.employeeDetails?.employeeStatus &&
                          errors.employeeDetails?.employeeStatus}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Employee Type
                      </Typography>
                      <Field
                        name="employeeDetails.employeeType"
                        className="InputField w-100"
                        placeholder="Enter Employee Type"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.employeeDetails?.employeeType &&
                          errors.employeeDetails?.employeeType &&
                          errors.employeeDetails?.employeeType}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <div className="wsh-form-control">
                        <Typography className="inputLabel">Project</Typography>
                        <Autocomplete
                          options={projectData}
                          multiple
                          disabled={disabled}
                          value={projectData.filter((option) =>
                            values.project.includes(option._id)
                          )}
                          onChange={(e, v) => {
                            // setFieldValue("project", v?._id);
                            setFieldValue(
                              "project",
                              v.map((option) => option._id)
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              focused={false}
                              placeholder="Select Project"
                              className="AutoComplete_InputBox"
                            />
                          )}
                        />
                        <div className="form-error">
                          {touched.project && errors.project && errors.project}
                        </div>
                      </div>
                    </Grid>
                    {/* <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Joining Date
                      </Typography>
                      <Field
                        name="joiningDate"
                        className="InputField w-100"
                        placeholder="Enter Employee Type"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.joiningDate &&
                          errors.joiningDate &&
                          errors.joiningDate}
                      </div>
                    </Grid> */}
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Joining Date
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker", "DatePicker"]}
                        >
                          <DatePicker
                            value={
                              values?.joiningDate
                                ? dayjs(values?.joiningDate)
                                : null
                            }
                            onChange={(e) =>
                              setFieldValue("joiningDate", dayjs(e.$d))
                            }
                            className="datePicker w-100"
                            disabled={disabled}
                            format="DD/MM/YYYY"
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <div className="form-error">
                        {touched.joiningDate &&
                          errors.joiningDate &&
                          errors.joiningDate}
                      </div>
                    </Grid>
                  </>
                )}
                {activeStep === 4 && (
                  <>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Account Number
                      </Typography>
                      <Field
                        name="accountDetails.accountNumber"
                        className="InputField w-100"
                        placeholder="Enter Account Number"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.accountDetails?.accountNumber &&
                          errors.accountDetails?.accountNumber &&
                          errors.accountDetails?.accountNumber}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Account Holder Name
                      </Typography>
                      <Field
                        name="accountDetails.accountHolderName"
                        className="InputField w-100"
                        placeholder="Enter Account Holder Name"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.accountDetails?.accountHolderName &&
                          errors.accountDetails?.accountHolderName &&
                          errors.accountDetails?.accountHolderName}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Bank Name</Typography>
                      <Field
                        name="accountDetails.bankName"
                        className="InputField w-100"
                        placeholder="Enter Bank Name"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.accountDetails?.bankName &&
                          errors.accountDetails?.bankName &&
                          errors.accountDetails?.bankName}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">Branch</Typography>
                      <Field
                        name="accountDetails.bankBranch"
                        className="InputField w-100"
                        placeholder="Enter Bank Branch"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.accountDetails?.bankBranch &&
                          errors.accountDetails?.bankBranch &&
                          errors.accountDetails?.bankBranch}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">IFSC No</Typography>
                      <Field
                        name="accountDetails.IFSCNumber"
                        className="InputField w-100"
                        placeholder="Enter IFSC Number"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.accountDetails?.IFSCNumber &&
                          errors.accountDetails?.IFSCNumber &&
                          errors.accountDetails?.IFSCNumber}
                      </div>
                    </Grid>
                  </>
                )}
              </Grid>
            </Box>
            <Grid className="addboxFooter">
              <Button
                className="cancelButton"
                sx={{ display: activeStep === 0 ? "flex" : "none" }}
                onClick={() => setOpenDrawer(false)}
              >
                Cancel
              </Button>
              {/* <Button
                type="button"
                onClick={handleBack}
                disabled={activeStep === 0}
              >
                Back
              </Button> */}
              <Button
                className="cancelButton"
                sx={{ display: activeStep !== 0 ? "flex" : "none" }}
                // className={Styles.cancelButton}
                onClick={() => setActiveStep(activeStep - 1)}
              >
                Previous
              </Button>
              <Button
                type="button"
                onClick={handleNext}
                sx={{
                  display: activeStep === steps.length - 1 ? "none" : "flex",
                }}
                // style={{
                //   color: "#FFFFFF",
                //   backgroundColor: "#141414",
                //   width: "fit-content",
                //   borderColor: "#141414",
                //   fontWeight: "600",
                //   textTransform: "none",
                // }}
                // variant="outlined"
                className="saveButton"
              >
                {activeStep === steps.length - 1 ? "Finish" : "Next"}
              </Button>

              <Button
                type="submit"
                className="saveButton"
                sx={{
                  display:
                    activeStep === steps.length - 1 && formType !== "view"
                      ? "flex"
                      : "none",
                }}
              >
                Save
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddUser;
